var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440 4688 c-42 -9 -77 -42 -508 -471 -255 -254 -472 -479 -483 -499 -23 -45 -25 -124 -4 -176 22 -51 904 -936 960 -963 51 -24 128 -24 180 0 72 32 125 113 125 191 0 80 -12 95 -288 372 l-266 268 1689 2 1690 3 45 25 c119 67 147 225 57 327 -18 20 -50 44 -72 54 -38 18 -117 19 -1725 19 l-1685 0 257 258 c263 263 297 306 298 377 0 55 -21 107 -62 151 -54 59 -126 80 -208 62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3550 2549 c-44 -18 -90 -59 -112 -102 -28 -53 -29 -137 -4 -187 10 -19 133 -151 274 -292 l257 -258 -1666 0 c-1871 0 -1734 6 -1807 -74 -66 -71 -77 -157 -33 -244 24 -47 45 -66 101 -91 45 -20 58 -21 1725 -21 l1680 0 -262 -263 c-143 -144 -268 -276 -277 -293 -53 -108 -10 -232 101 -288 45 -22 135 -21 181 3 55 29 948 927 967 973 19 48 19 118 0 166 -21 51 -903 934 -961 962 -43 22 -122 26 -164 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.5c88584ce41d544e0622adbb7d033782.svg";
export { ForwardRef as ReactComponent };